<template>
    <AppLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Initial Setup
            </h2>
        </template>

        <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
            <form @submit.prevent="submit">
                <div>
                    <div>
                        <div>
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Job board setup
                            </h3>
                            <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                This is information needed to create your own job board.
                            </p>
                        </div>
                        <div class="mt-6 sm:mt-5">

                            <div
                                class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                <label for="name"
                                       class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                    Board Name
                                </label>
                                <div class="mt-1 sm:mt-0 sm:col-span-2">
                                    <div class="max-w-lg flex rounded-md shadow-sm">
                                        <InputText id="name" v-model="form.name" placeholder="e.g Remote.ly"/>
                                    </div>
                                    <span class="text-red-400 text-sm" v-if="$page.errors.name">{{ $page.errors.name[0] }}</span>
                                </div>
                            </div>

                            <div
                                class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                <label for="slug"
                                       class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                    Board sub-domain
                                </label>
                                <div class="mt-1 sm:mt-0 sm:col-span-2">
                                    <div class="max-w-lg flex rounded-md shadow-sm">
                                        <input type="text" id="slug" v-model="form.slug"
                                               class="flex-1 rounded-none rounded-l-md border-gray-300 block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                               placeholder="name-of-your-site"/>
                                        <span
                                            class="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">.jobroll.co</span>
                                    </div>
                                    <span class="text-red-400 text-sm" v-if="$page.errors.slug">{{ $page.errors.slug[0] }}</span>
                                </div>
                            </div>

                            <div
                                class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                <label for="description"
                                       class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                    About your job board
                                </label>
                                <div class="mt-1 sm:mt-0 sm:col-span-2">
                                    <div class="max-w-lg flex">
                                    <textarea id="description" rows="3" v-model="form.description"
                                              class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md" />
                                    </div>
                                    <span class="text-red-400 text-sm" v-if="$page.errors.description">{{ $page.errors.description[0] }}</span>
                                    <p class="mt-2 text-sm text-gray-500">Write a few sentences about the job board.</p>
                                </div>
                            </div>

                            <div
                                class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                                <label for="logo" class="block text-sm leading-5 font-medium text-gray-700">
                                    Board Logo
                                </label>
                                <div>
                                <div class="max-w-lg flex rounded-md shadow-sm">
                                    <input id="logo" type="file" ref="board_logo" v-on:change="handleFile()"
                                           class="flex-1 block w-full sm:text-sm sm:leading-5"/>
                                </div>
                                <span class="text-red-400 text-sm" v-if="$page.errors.logo">{{ $page.errors.logo[0] }}</span>
                                <p class="mt-2 text-sm text-gray-500">Minimum width 200px. Maximum 4MB in file size.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-8 border-t border-gray-200 pt-5">
                    <div class="flex justify-end">
                    <span class="ml-3 inline-flex rounded-md shadow-sm">
        <button type="submit"
                class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
          Save
        </button>
      </span>
                    </div>
                </div>
            </form>
        </div>


    </AppLayout>
</template>

<script>

    import AppLayout from "@/Layouts/AppLayout";
    import InputText from "@/Jobroll/InputText";
    export default {
        components: {AppLayout, InputText},
        metaInfo: {title: 'Settings'},
        name: "Create",
        data() {
            return {
                form: {
                    name: null,
                    slug: null,
                    description: null,
                    logo: null
                }
            }
        },
        methods: {
            submit() {
                let data = new FormData();
                data.append('name', this.form.name || '');
                data.append('slug', this.form.slug || '');
                data.append('description', this.form.description || '');
                data.append('logo', this.form.logo || '');

                this.$inertia.post('/settings', data);
            },
            handleFile() {
                this.form.logo = this.$refs.board_logo.files[0];
            }
        }
    }
</script>
